import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

/**
 * Autenticação de e-mail por código (2FA para perfil CLIENTEFIEL).
 *
 * Endpoints do backend (base REST atual, sem Authorization):
 *   POST validacao-email/enviar-codigo   -> { email }
 *   POST validacao-email/validar-codigo  -> { email, codigo }
 *
 * Axios lança em respostas 4xx; por isso lemos error.response.data quando existe.
 */

/**
 * Solicita o envio de um código para o e-mail.
 * @param {string} email
 * @returns {Promise<{ sucesso: boolean, segundosRestantes?: number, erro?: string }>}
 */
export const enviarCodigo = async function (email) {
    try {
        const response = await api.post(
            "validacao-email/enviar-codigo",
            { email },
            { headers: { "Content-Type": "application/json" } }
        )
        return { sucesso: response.data?.sucesso === true }
    } catch (error) {
        const data = error?.response?.data
        if (data) {
            // 429 (cooldown) traz segundosRestantes; 400 traz erro de validação.
            return {
                sucesso: false,
                segundosRestantes: data.segundosRestantes,
                erro: data.erro || "Não foi possível enviar o código",
            }
        }
        RegistrarLogErro(error, "enviarCodigoEmail", { email })
        return { sucesso: false, erro: "Verifique sua conexão e tente novamente" }
    }
}

/**
 * Valida o código informado para o e-mail. Em caso de sucesso o backend consome o código.
 * @param {string} email
 * @param {string} codigo
 * @returns {Promise<{ valido: boolean, erro?: string }>}
 */
export const validarCodigo = async function (email, codigo) {
    try {
        const response = await api.post(
            "validacao-email/validar-codigo",
            { email, codigo },
            { headers: { "Content-Type": "application/json" } }
        )
        return { valido: response.data?.valido === true }
    } catch (error) {
        const data = error?.response?.data
        if (data) {
            return { valido: false, erro: data.erro || "Código inválido" }
        }
        RegistrarLogErro(error, "validarCodigoEmail", { email })
        return { valido: false, erro: "Verifique sua conexão e tente novamente" }
    }
}
